import axios from 'axios';
import { toast } from 'react-toastify';

// Define base URLs for device groups and devices
const DASHBOARD_API_URL = process.env.REACT_APP_DASHBOARD_URL || 'https://192.168.5.115:8082/device_mgmt_service/dashboard';
const DEVICE_GROUP_API_URL = process.env.REACT_APP_DeviceGroupAPI_URL || 'http://localhost:8081/deviceGroups';
const DEVICE_API_URL = process.env.REACT_APP_DeviceAPI_URL || 'http://localhost:8081/things';
const CATALOG_API_URL = process.env.REACT_APP_CatalogAPI_URL || 'http://localhost:8081/catalogs';
const JOB_MODULE_URL = process.env.REACT_APP_JOBS_MODULE_URL || 'http://localhost:8081/jobStatuses';
const DEVICE_MODEL_GROUP_API_URL = process.env.REACT_APP_DeviceModelGroupAPI_URL || 'http://localhost:8081';
const DEVICE_MODEL_API_URL = process.env.REACT_APP_DeviceModelAPI_URL || 'http://localhost:8088/device_mgmt_service';
const USER_API_URL = process.env.REACT_APP_USER_URL || 'https://192.168.5.115:8008/user_service/users';
const SEND_COMMAND_API = process.env.REACT_APP_SendCommand_URL || 'https://192.168.5.115:8082/device_mgmt_service/command';
const Firmware_API_URL = process.env.REACT_APP_FirmwareAPI_URL || 'https://192.168.5.115:9208/device_mgmt_service/firmwares';
const IOTJOBS_API_URL = process.env.REACT_APP_IOTJOBS_URL || 'https://192.168.5.115:8082/device_mgmt_service/otaJobs';
const ARTIFACT_API_URL = process.env.REACT_APP_ARTIFACT_URL || 'https://192.168.5.115:8082/device_mgmt_service/v1/ota/artifacts';
const DEVICE_POLICY_API_URL = process.env.REACT_APP_DevicePolicyAPI_URL || 'http://localhost:8088/device_mgmt_service/policies';
const CAMPAIGN_API_URL = process.env.REACT_APP_CAMPAIGN_URL || 'https://192.168.5.115:8082/device_mgmt_service/v1/ota/campaigns';
const ADMIN_USERS_API_URL = process.env.REACT_APP_ADMIN_USERS_URL || 'https://192.168.5.115:9208/device_mgmt_service/admin/users';
const ANALYTICS_API_URL = process.env.REACT_APP_ANALYTICS_URL || 'https://192.168.5.115:8082/device_mgmt_service/v1/analytics';
const token = localStorage.getItem('accessToken');
// Create axios instances for different APIs
const createAxiosInstance = (baseURL) => {
  const instance = axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  instance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('accessToken');
      if (token) {
        config.headers['Authorization'] = `Bearer ${token}`;
      }
      return config;
    },
  );
  return instance;
};

// Create axios instances for different APIs
const dashboardApi = createAxiosInstance(DASHBOARD_API_URL);
const deviceGroupApi = createAxiosInstance(DEVICE_GROUP_API_URL);
const deviceApi = createAxiosInstance(DEVICE_API_URL);
const catalogAPI = createAxiosInstance(CATALOG_API_URL);
const jobsModuleApi = createAxiosInstance(JOB_MODULE_URL);
const deviceModelGroupApi = createAxiosInstance(DEVICE_MODEL_GROUP_API_URL);
const deviceModelApi = createAxiosInstance(DEVICE_MODEL_API_URL);
const userModelApi = createAxiosInstance(USER_API_URL);
const sendCommandApi = createAxiosInstance(SEND_COMMAND_API);
const Firmware_API = createAxiosInstance(Firmware_API_URL);
const iotJobsApi = createAxiosInstance(IOTJOBS_API_URL);
const artifactApi = createAxiosInstance(ARTIFACT_API_URL);
const devicePolicyApi = createAxiosInstance(DEVICE_POLICY_API_URL);
const campaignApi = createAxiosInstance(CAMPAIGN_API_URL);
const adminUsersApi = createAxiosInstance(ADMIN_USERS_API_URL);
const analyticsApi = createAxiosInstance(ANALYTICS_API_URL);

// Device Group API calls
export const createDeviceGroup = (deviceGroup) => deviceGroupApi.post('', deviceGroup);
export const updateDeviceGroup = (id, deviceGroup) => deviceGroupApi.put(`/${id}`, deviceGroup);
export const deleteDeviceGroup = (id) => deviceGroupApi.delete(`/${id}`);
export const getAllDeviceGroups = (pageNo, pageSize, sortBy, sortOrder, searchValue) => {
  return deviceGroupApi.get('', {
    params: {
      pageNo,
      pageSize,
      sortBy,
      sortOrder,
      searchValue
    }
  });
};


// Device API calls
export const createThing = (thing) => deviceApi.post('', thing);
export const searchThings = (thingName) => deviceApi.get(`/aws?thingName=${thingName}`);
export const deleteThing = (thingName) => deviceApi.delete(`/${thingName}`);
export const getDeviceHealth = (thingName) => deviceApi.get(`/${encodeURIComponent(thingName)}/health`);
export const getDeviceMqttTopics = (thingName) => deviceApi.get(`/${encodeURIComponent(thingName)}/mqtt-topics`);
export const getAllDeviceDetails = (sortedQueryParam) => deviceApi.get('',
  {
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    params: {
      pageNo: sortedQueryParam.pageNo,
      pageSize: sortedQueryParam.pageSize,
      sortBy: sortedQueryParam.sortBy,
      sortOrder: sortedQueryParam.sortOrder,
      searchValue: sortedQueryParam.searchValue,
    }
  }
);

export const getAllHubDetails = (sortedQueryParam) => deviceApi.get('/hubs', {
  params: {
    pageNo: sortedQueryParam.pageNo,
    pageSize: sortedQueryParam.pageSize,
    sortOrder: sortedQueryParam.sortOrder,
    searchValue: sortedQueryParam.searchValue,
  }
});

export const getDevicesByModel = (deviceModelId, sortedQueryParam = {}) => deviceApi.get('', {
  params: {
    deviceModelId,
    pageNo: sortedQueryParam.pageNo ?? 0,
    pageSize: sortedQueryParam.pageSize ?? 500,
    sortBy: sortedQueryParam.sortBy,
    sortOrder: sortedQueryParam.sortOrder,
    searchValue: sortedQueryParam.searchValue,
  }
});

// Catalog API calls
export const createCatalog = (catalogs) => catalogAPI.post('', catalogs);
export const getAllCatalogs = (page = 0, rowsPerPage = 10, sortField = 'id', sortOrder = 'asc', searchValue = '') =>
  catalogAPI.get('', {
    params: {
      pageNo: page,
      pageSize: rowsPerPage,
      sortBy: sortField,
      sortOrder: sortOrder,
      searchValue: searchValue,
    }
  });

export const updateCatalog = (id, catalogs) => catalogAPI.put(`/${id}`, catalogs);
export const deleteCatalog = (id) => catalogAPI.delete(`/${id}`);

export const createCatalogDeviceCategory = (catalogId, category) => catalogAPI.post(`/${catalogId}/categories`, category);
export const deleteCategory = (id) => catalogAPI.delete(`/categories/${id}`);
export const updateCategory = (id, category) => catalogAPI.put(`/categories/${id}`, category);
export const getAllCategories = (pageNo, pageSize, sortBy, sortOrder, searchValue) => {
  return catalogAPI.get('/categories', {
    params: {
      pageNo,
      pageSize,
      sortBy,
      sortOrder,
      searchValue
    }
  });
};

export const getCategoriesByCatalogId = (catalogId, page = 0, rowsPerPage = 10, sortField = 'id', sortOrder = 'asc', searchValue = '') =>
  catalogAPI.get(`${catalogId}/categories`, {
    params: {
      pageNo: page,
      pageSize: rowsPerPage,
      sortBy: sortField,
      sortOrder: sortOrder,
      searchValue: searchValue,
    }
  });

// Jobs API Calls
export const getAllJobs = (page = 0, perPage = 10, sortField = 'jobId', sortOrder = 'asc', searchValue) =>
  jobsModuleApi.get('', {
    params: {
      pageNo: page,
      pageSize: perPage,
      sortBy: sortField,
      sortOrder: sortOrder,
      searchValue: searchValue
    }
  });


export const downloadDeviceDetailFile = async (id) => {
  try {
    const response = await jobsModuleApi.get(`/download/deviceDetails/${id}`, {
      responseType: 'blob' // Important for file download
    });
    console.log(response)
    // Create a link element, set the URL, and trigger a click to download
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `device_details_${id}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error('Failed to download file:', error);
    toast.error('Failed to download file');
  }
};


//Device Model Group API calls
export const createDeviceModelGroup = (categoryId, deviceModelGroup) => deviceModelGroupApi.post(`/categories/${categoryId}/groups`, deviceModelGroup);

export const getDeviceModelGroups = (page = 0, perPage = 10, sortField = 'id', sortOrder = 'asc', searchValue = '') =>
  deviceModelGroupApi.get(`/groups`, {
    params: {
      pageNo: page,
      pageSize: perPage,
      sortBy: sortField,
      sortOrder: sortOrder,
      searchValue: searchValue
    }
  });

export const getDeviceModelGroupById = (id) => deviceModelGroupApi.get(`/groups/${id}`);
export const updateDeviceModelGroup = (Id, deviceModelGroup) => deviceModelGroupApi.put(`/groups/${Id}`, deviceModelGroup);
export const deleteDeviceModelGroupById = (id) => deviceModelGroupApi.delete(`/groups/${id}`);
export const getDeviceModelGroupsByCategoryId = (categoryId, page = 0, perPage = 10, sortField = 'id', sortOrder = 'asc', searchValue = '') =>
  deviceModelGroupApi.get(`/categories/${categoryId}/groups`, {
    params: {
      pageNo: page,
      pageSize: perPage,
      sortBy: sortField,
      sortOrder: sortOrder,
      searchValue: searchValue
    }
  });


//Device Model API calls
export const createDeviceModel = (groupId, deviceModel) => deviceModelApi.post(`/groups/${groupId}/models`, deviceModel);
export const getAllDeviceModels = (page = 0, size = 10, sortBy = 'createdDate', sortOrder = 'desc', search = '') =>
  deviceModelApi.get('/models', {
    params: {
      page,
      size,
      sortBy,
      sortOrder,
      search
    }
  });

//Firmware Functionality
export const getAllFirmwareDetails = (sortedQueryParam) => {
  return Firmware_API.get('', {
    params: {
      pageNo: sortedQueryParam.pageNo,
      pageSize: sortedQueryParam.pageSize,
      sortBy: sortedQueryParam.sortBy,
      sortOrder: sortedQueryParam.sortOrder,
      searchValue: sortedQueryParam.searchValue,
      pagination: sortedQueryParam.pagination
    }
  });
};

// Iot Jobs
export const getAllIotJobs = (sortedQueryParam) => {
  return Firmware_API.get('iotJobs', {
    params: {
      pageNo: sortedQueryParam.pageNo,
      pageSize: sortedQueryParam.pageSize,
      sortBy: sortedQueryParam.sortBy,
      sortOrder: sortedQueryParam.sortOrder,
      searchValue: sortedQueryParam.searchValue,
    }
  });
}

// Campaigns
export const getAllCampaigns = (params) => {
  return campaignApi.get('', { params });
}

export const getCampaignById = (id) => {
  return campaignApi.get(`/${id}`);
}

export const createCampaign = (campaignData) => {
  return campaignApi.post('', campaignData);
}

export const updateCampaign = (id, campaignData) => {
  return campaignApi.put(`/${id}/status`, campaignData);
}

export const deleteCampaign = (id) => {
  return campaignApi.delete(`/${id}`);
}

export const getCampaignHubs = (id, params) => {
  return campaignApi.get(`/${id}/hubs`, { params });
}

export const getCampaignHubDevices = (campaignId, hubId, params) => {
  return campaignApi.get(`/${campaignId}/hubs/${hubId}/devices`, { params });
}

// OTA Artifacts
export const getAllOtaArtifacts = (params) => {
  return artifactApi.get('', { params });
};

export const deleteOtaArtifact = (id) => artifactApi.delete(`/${id}`);

export const createOtaArtifact = (formData) =>
  artifactApi.post("", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const parseOtaArtifactZip = (formData) =>
  artifactApi.post("/parse", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const updateOtaArtifact = (id, payload) => artifactApi.put(`/${id}`, payload);

export const downloadOtaArtifact = async (id, params) => {
  return await artifactApi.get(`/${id}/download`, { params });
};

export const IotJobStatus = (jobId, sortedQueryParam) => {
  const params = {
    size: sortedQueryParam.pageSize,
  };

  if (sortedQueryParam.nextToken) {
    params.nextToken = sortedQueryParam.nextToken;
  } else {
    params.pageNo = sortedQueryParam.pageNo; // Only send pageNo when nextToken is NOT present
  }

  return iotJobsApi.get(`/${jobId}/deviceStatus`, { params });
};

export const deleteFirmwareDetails = (id) => deviceModelGroupApi.get(`/firmwares/${id}`);


export const getDeviceModelById = (id) => deviceModelApi.get(`/models/${id}`);
export const updateDeviceModel = (Id, deviceModel) => deviceModelApi.put(`/models/${Id}`, deviceModel);

export const deleteDeviceModelById = (id) => deviceModelApi.delete(`/models/${id}`);


export const createUser = (user) => userModelApi.post('/register', user);
export const fetchRoleGroups = () => {
  return userModelApi.get('/roleGroups');
};
export const updateUser = (userId, userData) => {
  return userModelApi.put(`/${userId}/updateDetails`, userData);
};
// Users list (mobile app users + users created from the admin app), served by device_mgmt_service.
// options.userType: 'web' (admin portal users) or 'mobile' (app users); options.search: name or email.
export const getUsers = (pageNo, pageSize, sortBy, sortOrder, options = {}) => {
  const { search, userType } = options;
  return adminUsersApi.get('', {
    params: {
      pageNo,
      pageSize,
      sortBy,
      sortOrder,
      // Only sent when set.
      ...(search ? { search } : {}),
      ...(userType ? { userType } : {}),
    }
  });
};

export const deleteUser = (userId) => {
  return userModelApi.delete(`/${userId}`);
};

export const getUserByEmail = async (email) => {
  try {
    const response = await userModelApi.get(`/getUserByEmail/${email}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching user by email:', error);
    throw error;
  }
};

export const updateUserProfile = async (userId, data) => {
  try {
    const response = await userModelApi.put(`/${userId}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating user profile:', error);
    throw error;
  }
};

export const resetUserPassword = async (userId, newPassword, token, tenantId) => {
  const headers = {
    Authorization: `Bearer ${token}`,
    tenantId: tenantId,
  };

  const data = { value: newPassword }; // Payload for the API request

  try {
    const response = await userModelApi.put(`/${userId}/reset-password`, data, { headers });
    return response.data;
  } catch (error) {
    console.error('Error updating password:', error);
    throw error;
  }
};

export const fetchSendCommand = async (thingName, command) => {
  try {
    const response = await sendCommandApi.post(`/${thingName}/sendCommand`, command);
    return response.data;
  } catch (error) {
    console.error("Error sending command:", error);
    throw error;
  }
};

export const uploadFirmwareDetails = async (file, firmwareDetails) => {
  try {
    const formData = new FormData();
    const firmwareBlob = new Blob([JSON.stringify(firmwareDetails)], { type: "application/json" });
    formData.append("firmware", firmwareBlob);
    formData.append("file", file);

    const response = await Firmware_API.post("/upload", formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error uploading firmware:", error);
    throw error;
  }
};

export const deleteFirmware = (id) => Firmware_API.delete(`/${id}`);

export const downloadFirmware = async (id) => {
  return await Firmware_API.get((`/${id}/download`), {
    responseType: 'blob'
  });
}

export const getAllDeviceStatus = async (jobId) => {
  return await iotJobsApi.get(`/${jobId}/deviceStatus/summary`);
};

export const fetchTotalDevices = async () => {
  try {
    return await dashboardApi.get('/totalDevices');
  }
  catch (error) {
    return {
      "Total Devices": "No Data"
    };
  }
}

export const fetchTotalDeviceGroups = async () => {
  try {
    return await dashboardApi.get('/totalDeviceGroups');
  }
  catch (error) {
    return {
      "Device Groups": "No Data"
    };
  }
}

export const fetchTotalUsers = async () => {
  try {
    return (await userModelApi.get('/totalUsers')).data;
  }
  catch (error) {
    return {
      "Total Users": "No Data"
    };
  }
}

export const fetchTotalDeviceModels = async () => {
  try {
    return await dashboardApi.get('/totalDeviceModels');
  }
  catch (error) {
    return {
      "Device Models": "No Data"
    };
  }
}

export const fetchTotalCatalogs = async () => {
  try {
    return (await dashboardApi.get('/totalCatalogs')).data;
  }
  catch (error) {
    return {
      "Total Catalogs": "No Data"
    };
  }
}

export const totalDevicesByDeviceModel = async () => {
  try {
    return (await dashboardApi.get('/totalDevicesByModel')).data;
  }
  catch (error) {
    return {};
  }
}

// Device Policy API calls
export const getAllDevicePolicies = (params) => devicePolicyApi.get('', { params });

//Delete Policy API calls
export const deletePolicy = (id) => devicePolicyApi.delete(`/${id}`);

export const createDevicePolicy = async (policyData) => {
  try {
    const response = await devicePolicyApi.post('', {
      name: policyData.name,
      description: policyData.description,
      policyJson: policyData.policyJson,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateDevicePolicy = (id, policyData) => devicePolicyApi.put(`/${id}`, policyData);

// Internal staff users (ADMIN / OPERATOR / QA) in the admin-portal realm - device_mgmt_service.
// Body: { username, email, firstName, lastName, roles: [...] } -> { data: { username, generatedPassword } }
export const createAdminUser = (user) => adminUsersApi.post('', user);

// Analytics API calls
export const getAnalyticsDatasets = () => analyticsApi.get('/datasets');

export const getAnalyticsSeries = (datasetName, { fromDate, toDate, dimension } = {}) =>
  analyticsApi.get(`/datasets/${encodeURIComponent(datasetName)}/series`, {
    params: {
      fromDate,
      toDate,
      dimension: dimension || undefined,
    }
  });

export const getAnalyticsSummary = (asOfDate) =>
  analyticsApi.get('/summary', {
    params: {
      asOfDate: asOfDate || undefined,
    }
  });
